import { RadarAnimation } from '@/components/RadarAnimation'

export const RadarLoader = () => (
  <div className="pointer-events-none absolute -top-[36%] bottom-0 left-0 right-0 z-0 flex h-full items-center justify-center">
    <div className="absolute z-0 ml-16 mt-12 flex h-[600px] w-[600px] items-center justify-center">
      <RadarAnimation />
    </div>
  </div>
)
